export default __webpack_public_path__ + "static/media/top.31676b79.png";